module.exports = __webpack_public_path__ + "img/upperabs.531e0dff.svg";